import NODES from "@/statics/devices/Nodes.js";
import Logger from "@/statics/logger.js";
import Messaging from "@/statics/messaging.js";

var messaging = new Messaging(new Logger(false));

const NODES_PARAMETERS_ACTIONS = {
  updateNodeListAndStates: function (store, hubIndex) {
    return new Promise((resolve, reject) => {
      var hub = store.state.hubs[hubIndex];

      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: store.state.user.uuid,
      });
      store
        .dispatch("getNodeListAndStates", { messagingHook: messagingHook, hubUUID: hub.uuid })
        .then((response) => {
          resolve(response);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  processNodeListAndStates: function (store, nodeStats) {
    for (var j = 0; j < nodeStats.length; j++) {
      var node = store.getters.getNodeByUUID(nodeStats[j].uuid);
      var nodeStat = nodeStats[j];
      const hub = store.state.hubs[nodeStats.hubIndex];
      if (node == -1) {
        nodeStat.hubIndex = nodeStats.hubIndex;
        const name = hub.uuid === nodeStats[j].uuid ? store.getters.language.texts.Node2Name.replace('{}', hub.name) : NODES[nodeStat.deviceType].NAME + " 0x" + messaging.utility.uuidToHexString(nodeStat.uuid).toUpperCase();
        var nodeContex = {
          name: name,
          color: 0,
          uuid: nodeStat.uuid,
          hubUUID: hub.uuid,
          deviceType: nodeStat.deviceType,
          firmwareYear: nodeStat.firmwareYear,
          firmwareMonth: nodeStat.firmwareMonth,
          parameterList: nodeStat.parameterList,
          isPaired: nodeStat.isOnline == 255 ? false : true,
        };
        store.dispatch("addNode" + nodeStats[j].deviceType, nodeContex);
        store.commit("saveState");
      } else {
        var nodeStatIsPaired = nodeStat.isOnline == 255 ? false : true;
        if (node.isPaired != nodeStatIsPaired) {
          store.commit("setNodeIsPaired", { nodeIndex: node.index, isPaired: nodeStatIsPaired });
          store.commit("saveState");
        }
      }
    }
    var nodeCount = store.state.nodes.length;
    var nodeFound = false;
    for (var i = nodeCount - 1; i >= 0; i--) {
      nodeFound = false;
      for (j = 0; j < nodeStats.length; j++) {
        if (store.state.nodes[i].uuid == nodeStats[j].uuid) {
          nodeFound = true;
          break;
        }
      }
      if (!nodeFound) {
        if (store.state.nodes[i].hubUUID == store.state.hubs[nodeStats.hubIndex].uuid) {
          //TODO: when a node is deleted, everything is affected everywhere, so should we handle all of them here?
          var widgetCount = store.state.widgets.length;
          for (j = widgetCount - 1; j >= 0; j--) {
            if (store.state.widgets[j].type == "singleSwitchWidget" || store.state.widgets[j].type == "S1TouchWidget" || store.state.widgets[j].type == "singleThreewayWidget") {
              for (var k = 0; k < store.state.widgets[j].nodeUUIDs.length; k++) {
                if (store.state.widgets[j].nodeUUIDs[k] == store.state.nodes[i].uuid) {
                  store.commit("deleteWidget", j);
                  break;
                }
              }
            } else if (store.state.widgets[j].type == "sceneButtonWidget") {
              var widget = store.state.widgets[j];
              for (k = 0; k < widget.settings.commands.length; k++) {
                for (var l = 0; l < widget.settings.commands[k].actions.length; l++) {
                  if (widget.settings.commands[k].actions[l].nodeUUID == store.state.nodes[i].uuid) {
                    store.commit("deleteWidget", j);
                    break;
                  }
                }
              }
            }
          }
          store.commit("deleteNode", i);
          store.commit("saveState");
        }
      }
    }
    for (i = 0; i < nodeStats.length; i++) {
      node = store.getters.getNodeByUUID(nodeStats[i].uuid);
      if (node != -1) {
        var connectionStatus = nodeStats[i].isOnline;
        store.commit("setNodeStateAndParameters", { nodeIndex: node.index, rawParameters: nodeStats[i].parameterList, connectionStatus: connectionStatus });
      }
    }
  },
  processNodeParameters: function (store, nodeParameters) {
    var node = store.getters.getNodeByUUID(nodeParameters.nodeUUID);
    if (node != -1) {
      store.commit("setNodeParameters", { nodeIndex: node.index, rawParameters: nodeParameters.rawParameters });
    }
  },
};
export default NODES_PARAMETERS_ACTIONS;
